import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private readonly responseScrollSource = new BehaviorSubject<boolean>(true);
  currentResponseScroll = this.responseScrollSource.asObservable();

  constructor() { }

  changeResponseScroll(isScroll: boolean) {
    this.responseScrollSource.next(isScroll);
  }
}